"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockText = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const HighlightCode_1 = tslib_1.__importDefault(require("../../../1-inline/HighlightCode"));
const blockClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.lightTheme.font.mono.mid,
    fz: '12px',
    pad: '0 8px',
    mar: 0,
    pre: {
        mar: 0,
        pad: 0,
    },
});
const BlockText = ({ src, compact, select, lang }) => {
    const style = {
        padding: compact ? '0' : undefined,
        fontSize: compact ? '11px' : undefined,
    };
    return (React.createElement("pre", { className: blockClass, style: style, onMouseDown: select
            ? (event) => {
                const el = event.nativeEvent.target;
                if (!el)
                    return;
                if (window.getSelection && document.createRange) {
                    const selection = window.getSelection();
                    if (!selection)
                        return;
                    event.preventDefault();
                    const range = document.createRange();
                    range.selectNodeContents(el);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
            : void 0 }, lang ? React.createElement(HighlightCode_1.default, { code: src, lang: lang }) : React.createElement("code", null, src)));
};
exports.BlockText = BlockText;
